import type { SVGProps } from 'react';

export const DiscoverIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6.25 13.4375H10.75V14.5625H6.25V13.4375Z" fill="currentColor" />
    <path
      d="M4.5625 14.5625C4.87316 14.5625 5.125 14.3107 5.125 14C5.125 13.6893 4.87316 13.4375 4.5625 13.4375C4.25184 13.4375 4 13.6893 4 14C4 14.3107 4.25184 14.5625 4.5625 14.5625Z"
      fill="currentColor"
    />
    <path
      d="M10.1875 12.3125C10.4982 12.3125 10.75 12.0607 10.75 11.75C10.75 11.4393 10.4982 11.1875 10.1875 11.1875C9.87684 11.1875 9.625 11.4393 9.625 11.75C9.625 12.0607 9.87684 12.3125 10.1875 12.3125Z"
      fill="currentColor"
    />
    <path
      d="M4 11.1875H8.5V12.3125H4V11.1875ZM6.25 8.9375H10.75V10.0625H6.25V8.9375Z"
      fill="currentColor"
    />
    <path
      d="M4.5625 10.0625C4.87316 10.0625 5.125 9.81066 5.125 9.5C5.125 9.18934 4.87316 8.9375 4.5625 8.9375C4.25184 8.9375 4 9.18934 4 9.5C4 9.81066 4.25184 10.0625 4.5625 10.0625Z"
      fill="currentColor"
    />
    <path
      d="M19.7502 19.9625L15.5877 15.8C16.4314 14.675 16.9377 13.2688 16.9377 11.75C16.9377 8.0375 13.9002 5 10.1877 5C8.33145 5 6.5877 5.73125 5.29395 7.1375L6.1377 7.925C7.1502 6.74375 8.6127 6.125 10.1877 6.125C13.2814 6.125 15.8127 8.65625 15.8127 11.75C15.8127 14.8438 13.2814 17.375 10.1877 17.375C8.5002 17.375 6.9252 16.6438 5.85645 15.35L5.0127 16.0813C6.2502 17.6 8.1627 18.5 10.1877 18.5C11.9877 18.5 13.6189 17.7688 14.8564 16.6438L18.9627 20.75L19.7502 19.9625Z"
      fill="currentColor"
    />
  </svg>
);

export const LensIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.1719 4.97862C13.6794 4.06193 14.8343 3.72991 15.751 4.23741L16.0371 4.39659C16.9535 4.90422 17.2848 6.05818 16.7773 6.97472L16.4883 7.49425C17.9792 9.04135 18.5703 10.6602 18.4902 12.1466C18.4075 13.6817 17.6138 15.0021 16.5078 15.8751C15.676 16.5315 14.6502 16.9473 13.5889 17.0089V19.0509H15.96C16.2219 19.0509 16.4345 19.2636 16.4346 19.5255C16.4346 19.7874 16.2219 20.0001 15.96 20.0001H9.32031C9.05836 20.0001 8.8457 19.7874 8.8457 19.5255C8.84578 19.2636 9.05841 19.0509 9.32031 19.0509H12.6406V16.9659C12.6075 16.961 12.5741 16.9579 12.541 16.9523C11.1978 16.7218 9.93658 15.8798 9.04883 14.3087H6.47461C6.21268 14.3087 6.00003 14.096 6 13.8341C6 13.5721 6.21266 13.3595 6.47461 13.3595H12.166C12.4279 13.3595 12.6406 13.5722 12.6406 13.8341C12.6406 14.096 12.4279 14.3086 12.166 14.3087H10.2305C10.943 15.3147 11.8285 15.8156 12.71 15.9669C13.8121 16.156 14.976 15.8094 15.8877 15.09C16.7971 14.3722 17.4268 13.3065 17.4922 12.0929C17.5512 10.9969 17.1516 9.72108 15.9795 8.41417L14.708 10.712C14.2005 11.6287 13.0466 11.9607 12.1299 11.4532L11.8438 11.295C10.9271 10.7875 10.595 9.63262 11.1025 8.71593L13.1719 4.97862ZM15.291 5.06749C14.8328 4.81401 14.2558 4.97964 14.002 5.43761L11.9326 9.17589C11.679 9.6341 11.8447 10.2111 12.3027 10.465L12.5889 10.6232C13.0472 10.8769 13.6252 10.7114 13.8789 10.253L15.9482 6.51573C16.202 6.05739 16.0355 5.47944 15.5771 5.22569L15.291 5.06749Z"
      fill="currentColor"
    />
  </svg>
);

export const MindmapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 6.52632C12.335 6.52632 12.6563 6.39323 12.8932 6.15635C13.1301 5.91946 13.2632 5.59817 13.2632 5.26316C13.2632 4.92815 13.1301 4.60686 12.8932 4.36997C12.6563 4.13308 12.335 4 12 4C11.665 4 11.3437 4.13308 11.1068 4.36997C10.8699 4.60686 10.7368 4.92815 10.7368 5.26316C10.7368 5.59817 10.8699 5.91946 11.1068 6.15635C11.3437 6.39323 11.665 6.52632 12 6.52632ZM12 6.52632L11.1579 10.3158M12.4211 11.5789C12.4211 11.7448 12.3884 11.9091 12.3249 12.0623C12.2614 12.2156 12.1684 12.3548 12.0511 12.4721C11.9338 12.5894 11.7945 12.6825 11.6413 12.746C11.488 12.8094 11.3238 12.8421 11.1579 12.8421C10.992 12.8421 10.8278 12.8094 10.6745 12.746C10.5213 12.6825 10.382 12.5894 10.2647 12.4721C10.1474 12.3548 10.0544 12.2156 9.99089 12.0623C9.92741 11.9091 9.89474 11.7448 9.89474 11.5789C9.89474 11.2439 10.0278 10.9226 10.2647 10.6858C10.5016 10.4489 10.8229 10.3158 11.1579 10.3158M12.4211 11.5789C12.4211 11.2439 12.288 10.9226 12.0511 10.6858C11.8142 10.4489 11.4929 10.3158 11.1579 10.3158M12.4211 11.5789L15.7937 11.8686M13.2632 6.10526L16.6316 10.3158M14.1053 14.9474L10.7368 17.4737M8.63158 16.6316L6.10526 9.89474M7.21095 7.49811L10.7368 5.68421M20 12C20 12.2765 19.9455 12.5502 19.8397 12.8056C19.7339 13.0611 19.5789 13.2932 19.3834 13.4886C19.1879 13.6841 18.9558 13.8392 18.7004 13.945C18.445 14.0508 18.1712 14.1053 17.8947 14.1053C17.6183 14.1053 17.3445 14.0508 17.0891 13.945C16.8337 13.8392 16.6016 13.6841 16.4061 13.4886C16.2106 13.2932 16.0555 13.0611 15.9497 12.8056C15.8439 12.5502 15.7895 12.2765 15.7895 12C15.7895 11.4416 16.0113 10.9062 16.4061 10.5114C16.8009 10.1165 17.3364 9.89474 17.8947 9.89474C18.4531 9.89474 18.9886 10.1165 19.3834 10.5114C19.7782 10.9062 20 11.4416 20 12ZM7.36842 8.21053C7.36842 8.65721 7.19098 9.08559 6.87513 9.40144C6.55928 9.71729 6.13089 9.89474 5.68421 9.89474C5.23753 9.89474 4.80914 9.71729 4.49329 9.40144C4.17744 9.08559 4 8.65721 4 8.21053C4 7.76385 4.17744 7.33546 4.49329 7.01961C4.80914 6.70376 5.23753 6.52632 5.68421 6.52632C6.13089 6.52632 6.55928 6.70376 6.87513 7.01961C7.19098 7.33546 7.36842 7.76385 7.36842 8.21053ZM10.7368 18.3158C10.7368 18.7625 10.5594 19.1909 10.2435 19.5067C9.9277 19.8226 9.49931 20 9.05263 20C8.60595 20 8.17757 19.8226 7.86171 19.5067C7.54586 19.1909 7.36842 18.7625 7.36842 18.3158C7.36842 17.8691 7.54586 17.4407 7.86171 17.1249C8.17757 16.809 8.60595 16.6316 9.05263 16.6316C9.49931 16.6316 9.9277 16.809 10.2435 17.1249C10.5594 17.4407 10.7368 17.8691 10.7368 18.3158Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ManuscriptIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 4.5H13.2324C13.603 4.5 13.9609 4.63687 14.2363 4.88477L17.4482 7.77539C17.7643 8.05983 17.9443 8.46543 17.9443 8.89062V18C17.9443 18.8284 17.2728 19.5 16.4443 19.5H8C7.17157 19.5 6.5 18.8284 6.5 18V6C6.5 5.17157 7.17157 4.5 8 4.5Z"
      stroke="currentColor"
    />
    <path
      d="M13.1111 4.44444V7.33333C13.1111 8.4379 14.0065 9.33333 15.1111 9.33333H18"
      stroke="currentColor"
    />
    <line x1="8.66667" y1="11.5" x2="15.7778" y2="11.5" stroke="currentColor" />
    <line
      x1="8.66667"
      y1="14.1667"
      x2="15.7778"
      y2="14.1667"
      stroke="currentColor"
    />
    <line
      x1="8.66667"
      y1="16.8333"
      x2="15.7778"
      y2="16.8333"
      stroke="currentColor"
    />
  </svg>
);

// Spiral-bound notebook glyph — visually distinct from the
// document-with-folded-corner ManuscriptIcon. The three binding dots
// + horizontal divider read as "notebook" at sidebar size.
export const NotesIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="5.5" y="5" width="13" height="14.5" rx="1.5" stroke="currentColor" />
    <line x1="5.5" y1="8.5" x2="18.5" y2="8.5" stroke="currentColor" />
    <circle cx="8.5" cy="6.75" r="0.6" fill="currentColor" />
    <circle cx="12" cy="6.75" r="0.6" fill="currentColor" />
    <circle cx="15.5" cy="6.75" r="0.6" fill="currentColor" />
    <line x1="8.5" y1="11.75" x2="15.5" y2="11.75" stroke="currentColor" />
    <line x1="8.5" y1="14.25" x2="15.5" y2="14.25" stroke="currentColor" />
    <line x1="8.5" y1="16.75" x2="13" y2="16.75" stroke="currentColor" />
  </svg>
);

export const CitationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="6.5"
      y="4.5"
      width="11.4444"
      height="15"
      rx="1.5"
      stroke="currentColor"
    />
    <path
      d="M16.1663 4.5V11.5361L14.3792 9.45215L14.0003 9.00977L13.6204 9.45215L11.8333 11.5361V4.5H16.1663Z"
      stroke="currentColor"
    />
  </svg>
);
